import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Search from "./Search";
import { getContestsList } from "../../store/slices/contestSlice";
import ParticipantModel from "../models/ParticipantModel";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddPoll from "../models/AddPoll";
import ContestCell from "./ContestCell";
import ContestParticipantModel from "../models/ContestParticipantModel";
import ContestWinnerModel from "../models/ContestWinnerModel";
import CreateContest from "../models/CreateContest";
import UpdateContest from "../models/UpdateContest";
import OptionalInfoModel from "../models/OptionalInfoModel";

const Contests = () => {
    const dispatch = useDispatch();
    const { isLoading, filteredContests, totalRecordsReach, isModelOpen, isWinnerModelOpen,isOptionalModelOpen, isSearching } = useSelector((state) => state.contest);
    const [page, setPage] = useState(1);
    const scrollContainerRef = useRef(null);
    const [createContestModel, setCreateContestModel] = useState(false);
    const [updateContestModel, setUpdateContestModel] = useState(false);

    const loadMoreContests = () => {
        if (totalRecordsReach) return false;
        setPage((prevPage) => {
            const nextPage = prevPage + 1;
            dispatch(getContestsList({ page: nextPage, limit: 5 }));
            return nextPage;
        });
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
    
        const handleScroll = () => {
            if (isLoading || isSearching) return;
    
            const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
    
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                loadMoreContests();
            }
        };
    
        if (!isSearching) {
            scrollContainer.addEventListener("scroll", handleScroll);
        }
    
        return () => {
            scrollContainer.removeEventListener("scroll", handleScroll);
        };
    }, [isLoading, isSearching, totalRecordsReach]);

    return (
        <div className="polls-box">
            <Search />

            <div
                className="scrollable-container position-relative"
                ref={scrollContainerRef}
                style={{  overflow: "hidden auto" }}
            >
                {filteredContests?.length > 0 ? (
                    filteredContests.map((contest, index) => (
                        <ContestCell key={contest.id || index} contest={contest} setUpdateContestModel={setUpdateContestModel}/>
                    ))
                ) : !isLoading ? (
                    <div className="d-flex justify-content-center align-items-center p-4">
                        <span className="text-muted">No Record Found</span>
                    </div>
                ) : null}

                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center p-4">
                        <div
                            className="spinner-border text-primary"
                            style={{ width: "2rem", height: "2rem" }}
                            role="status"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>


            <div className="add_button">
                <AddCircleIcon className="plus_icon"
                    onClick={() => { setCreateContestModel(true) }}
                />
            </div>
            <ContestParticipantModel show={isModelOpen} />
            <ContestWinnerModel show={isWinnerModelOpen} />

            <CreateContest show={createContestModel} onClose={() => { setCreateContestModel(false) }} />
            <UpdateContest show={updateContestModel} onClose={() => { setUpdateContestModel(false) }} />
            <OptionalInfoModel heading="Optional Info" show={isOptionalModelOpen} />
        </div>
    );
};

export default Contests;